import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeValue } from '@angular/platform-browser';
import { SafeValue as SafeValueEnum } from './models/safe-value.enum';
import { Guard } from '../misselaineous/guards';

@Pipe({
    name: 'sanitizer',
    pure: false,
})
export class SanitizerPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(value: string, type: SafeValueEnum): SafeValue {
        Guard.against.nullOrUndefined(type);
        if (Guard.is.nullOrWhitespace(value)) {
            return;
        }
        switch (type) {
            case SafeValueEnum.SafeHtml:
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case SafeValueEnum.SafeStyle:
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case SafeValueEnum.SafeScript:
                return this.sanitizer.bypassSecurityTrustScript(value);
            case SafeValueEnum.SafeUrl:
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case SafeValueEnum.SafeResourceUrl:
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error("SafeValueType not found.");
        }
    }

}
